var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-view",staticStyle:{"height":"100%"}},[_c('TopHeader'),_c('div',{staticClass:"pt-12",staticStyle:{"height":"100%"}},[_c('router-view')],1),_c('Ie11Alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }